import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SalonOrderService } from "../../../salonorder/salonorder.service";

@Component({
  selector: "order-salonfastaccess",
  templateUrl: "./salonfastaccess.component.html",
  styleUrls: ["./salonfastaccess.component.scss"],
})
export class SalonFastAccessComponent extends BaseListComponent {
  constructor(public salonorder: SalonOrderService) {
    super();
    salonorder.getSalon();
  }
}
